import { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorHandler from '@Root/ErrorHandler';
import { IoClose as Close } from 'react-icons/io5';
import { MdWarning as Warning } from 'react-icons/md';
import { MdDeleteForever as Delete } from 'react-icons/md';
import FormAgentService from '@Helpers/URLHelpers/KaiziqResolve/FormAgentService';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import './DeleteFormAgentForm.scss';


export default function DeleteFormAgentForm(props) {

    const [cursor, setCursor] = useState('auto');
    const [user, setUser] = useState();
    const formAgentService = new FormAgentService();
    const userInfoService = new UserInfoService();
    const errorHandler = new ErrorHandler();
    const className = 'deleteFormAgentForm';
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1'];

    useEffect(() => {
        renderData();
    }, [props])

    const renderData = async() => {
        await renderUserData();
    }

    const renderUserData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let userObj = await userInfoService.getUserById(props.formAgent.userId);
                userObj = JSON.parse(userObj.body);
                setUser(userObj);
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return true;
    }

    const timeout = (delay: number) => {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleDelete = async(e) => {
        e?.preventDefault();
        setCursor('wait');
        try {
            let body = {
                id: props.formAgent?.id
            }
            await formAgentService.deleteFormAgent(body);
            await timeout(500);
            props.reloadData();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    const getInitials = (name) => {
        if (!name) return 'NA';
        const names = name.split(' ');
        if (names.length >= 2) {
            return names[0][0] + names[names.length - 1][0];
        }
        return names[0][0];
    };

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            onKeyPress={(e) => {
                if (e.key === "Enter") {
                    handleDelete();
                }
            }}>
            <div className={className}>
                <div className={`${className}__modal`}>
                    {/* Header */}
                    <div className={`${className}__header`}>
                        <div className={`${className}__header__left`}>
                            <Warning className={`${className}__header__icon`} />
                            <div className={`${className}__header__text`}>
                                <h2 className={`${className}__header__title`}>Remove Agent</h2>
                                <p className={`${className}__header__subtitle`}>
                                    This agent will no longer receive notifications
                                </p>
                            </div>
                        </div>
                        <button 
                            className={`${className}__header__closeBtn`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            <Close />
                        </button>
                    </div>

                    {/* Body */}
                    <div className={`${className}__body`}>
                        {/* User Info */}
                        <div className={`${className}__user`}>
                            {user?.photo ? (
                                <img 
                                    src={URL.createObjectURL(dataURLtoFile(user.photo))}
                                    className={`${className}__user__avatar`}
                                    alt='profile'
                                />
                            ) : (
                                <Avatar 
                                    className={`${className}__user__avatar`}
                                    sx={{ 
                                        bgcolor: colorList[user?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                                        width: 64,
                                        height: 64
                                    }}
                                >
                                    {getInitials(user?.fullName)}
                                </Avatar>
                            )}
                            <div className={`${className}__user__info`}>
                                <div className={`${className}__user__name`}>{user?.fullName}</div>
                                <div className={`${className}__user__username`}>@{user?.userName}</div>
                            </div>
                        </div>

                        {/* Warning Message */}
                        <div className={`${className}__warning`}>
                            <Warning className={`${className}__warning__icon`} />
                            <div className={`${className}__warning__content`}>
                                <h3 className={`${className}__warning__title`}>
                                    Are you sure you want to remove this agent?
                                </h3>
                                <ul className={`${className}__warning__list`}>
                                    <li>This user will no longer receive form notifications</li>
                                    <li>They can be re-added as an agent at any time</li>
                                    <li>This action is reversible</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className={`${className}__footer`}>
                        <button
                            className={`${className}__footer__cancelBtn`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            Cancel
                        </button>
                        <button
                            className={`${className}__footer__deleteBtn`}
                            onClick={handleDelete}
                            disabled={cursor === 'wait'}
                        >
                            {cursor === 'wait' ? (
                                <CircularProgress size={20} sx={{ color: 'white' }} />
                            ) : (
                                <>
                                    <Delete />
                                    Remove Agent
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
